"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSearchV2ResolveEndpointRequest = void 0;
const includes_1 = require("./includes");
function createSearchV2ResolveEndpointRequest(parameters) {
    return {
        method: 'GET',
        endpoint: `/v2/search/resolve`,
        params: Object.assign(Object.assign({ term: parameters.term }, (parameters.categoryId
            ? { categoryId: parameters.categoryId }
            : undefined)), (0, includes_1.searchV2WithParamsToQuery)(parameters.with)),
    };
}
exports.createSearchV2ResolveEndpointRequest = createSearchV2ResolveEndpointRequest;
